import { render, staticRenderFns } from "./UnaddressedPopup.vue?vue&type=template&id=c0ae2768&"
import script from "./UnaddressedPopup.vue?vue&type=script&lang=js&"
export * from "./UnaddressedPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UnaddressedPopup.vue"
export default component.exports